import { useEffect } from 'react';
import { setMetaMenuRoute, setMetaMenuState } from '../../../stores/actions/session';
import { useDispatch } from 'react-redux';
import { META_MENU_ROUTES, META_MENU_STATES } from '../../../stores/reducers/session';
import { updateFeatureFlag } from '../../../stores/actions/settings';

export default function UseQueryStrings() {
	const dispatch = useDispatch();
	
	const asyncFunction = async (time: number) => {
		return new Promise((resolve) => {
			setTimeout(() => {
				resolve(true);
			}, time);
		});
	};

	const runApplyQueryStrings = async () => {
		// 3 second window to make sure page is loaded
		
		if (window.location.search.includes('test=vbgs')) {
			await asyncFunction(3000);
			dispatch(updateFeatureFlag(['use_virtual_bgs', true]));
		}


		if (window.location.search.includes('test=effects')) {
			// this feature flag doesn't like to be changed set right away
			dispatch(setMetaMenuState(META_MENU_STATES.OPEN));
			dispatch(setMetaMenuRoute(META_MENU_ROUTES.EFFECTS));
		}

		if (window.location.search.includes('test=devices')) {
			//ff dont like being set right aways
			dispatch(setMetaMenuState(META_MENU_STATES.OPEN));
			dispatch(setMetaMenuRoute(META_MENU_ROUTES.PRESENTER_SETTINGS));
		}
	}

	useEffect(() => {
		//use query strings to open views/trigger functionality for fast testing on reloads
		runApplyQueryStrings();
	}, []);
}